import { gql } from '@apollo/client';

export const createWorkflowFolderMutation = gql`
  mutation CreateWorkflowFolder($name: String!, $locationId: Long) {
    createWorkflowFolder(name: $name, locationId: $locationId)
  }
`;
export const moveJourneyContentsAndFoldersMutation = gql`
  mutation MoveJourneyContentsAndFolders(
    $folderIds: [Long!]!
    $content: [JourneyIdAndTypeInput!]!
    $destinationId: Long!
  ) {
    moveContentsAndFolders: moveJourneyContentsAndFolders(
      folderIds: $folderIds
      content: $content
      destinationId: $destinationId
    ) {
      movedContent {
        id
        name
      }
      errors {
        ... on ContentsAndFoldersFailure {
          __typename
        }
      }
    }
  }
`;

export const renameWorkflowFolderMutation = gql`
  mutation RenameWorkflowFolder($folderId: Long!, $newName: String!) {
    renameWorkflowFolder(folderId: $folderId, newName: $newName) {
      ... on FolderRenamed {
        success {
          folderId
          folderName
        }
      }
      ... on RenameFailure {
        failure {
          ... on CannotRenameRootFolderFailure {
            id
          }
          ... on FolderNameConflictFailure {
            id
            name
          }
          ... on InvalidFolderNameFailure {
            id
            name
          }
        }
      }
    }
  }
`;

export const deleteJourneyContentsAndFoldersMutation = gql`
  mutation DeleteJourneyContentsAndFolders(
    $folderIds: [Long!]!
    $content: [JourneyIdAndTypeInput!]!
  ) {
    deleteContentsAndFolders: deleteJourneyContentsAndFolders(
      folderIds: $folderIds
      content: $content
    ) {
      deletedContent {
        id
        name
      }
      folderFailures {
        ... on ContentsAndFoldersFailure {
          __typename
        }
      }
    }
  }
`;
